import { AfterViewInit, Component, Input, OnInit, ViewChild } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MaterialModule } from 'src/app/material.module';
import { ReplacePatientTermPipe, SanitizeHtmlPipe } from '../filter-section.pipe';
import { SharedDataService } from 'src/services/shared-data.service';
import { ResponseService } from 'src/services/response.service';
import { FormsModule } from '@angular/forms';
import { combineLatest, throwError } from 'rxjs';
import { ResponseText } from 'src/models/app-enums.model';
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { QuestionnaireResponseAnswer, QuestionnaireResponseQuestion } from 'src/models/questionnaire-response.model';
import { ResponseAnswerUpdateRequest } from 'src/models/response.model';
import { DateUtil } from 'src/app/shared/utils/date.util';

@Component({
  selector: 'app-radio-button-vertical',
  templateUrl: './radio-button-vertical.component.html',
  styleUrls: ['./radio-button-vertical.component.scss'],
  standalone: true,
  imports: [MaterialModule, CommonModule, FormsModule, ReplacePatientTermPipe, SanitizeHtmlPipe]
})
export class RadioButtonVerticalComponent implements OnInit, AfterViewInit {

  @Input() question!: QuestionnaireResponseQuestion;
  @Input() otherAnswerPlaceholder!: string;
  @ViewChild("myTextArea") textArea!: any

  emptyOtherTextBoxMessage: string = $localize`:Specify Other Textbox Error Message |Error message displayed the specify other textbox is left empty@otherTextBoxValidationMessage:"Other" textbox cannot be empty.`;
  validation_msgs = {
    'otherTextboxInputControl': [
      { type: 'invalidOtherTextboxObject', message: this.emptyOtherTextBoxMessage}
    ]
  }

  patientTerm!: string;
  isPreview: boolean = false
  isPhonePortrait: boolean = false;
  isOtherTextBoxDisabled: boolean = false;
  isOtherTextboxValid: boolean = true;
  maxOtherAnswerCount = ResponseText.maxOtherAnswerCount;

  constructor(
    private _sharedDataService: SharedDataService, 
    private _responseService: ResponseService,
    private _responsive: BreakpointObserver
  ) {}

  ngAfterViewInit(): void {
    
    let inputAr = document.getElementsByTagName("input");
    
    for(let i=0;i<inputAr.length;i++){
      if(inputAr[i].getAttribute("type")?.toLowerCase()=="text"){
        let lbl = inputAr[i].getAttribute("aria-labelledby") || "";
        if(lbl.indexOf(" ")>-1){
          inputAr[i].setAttribute("aria-labelledby", lbl.split(" ").join(""));
        }
        let parentNode = <HTMLElement>inputAr[i].parentNode;
        parentNode.setAttribute("id", lbl.split(" ").join(""));
        let nodeName = parentNode?.nodeName.toLowerCase();
        if(nodeName=="label"){
          if(parentNode?.getElementsByTagName("label").length>0){
            let lblElm = parentNode?.getElementsByTagName("label")[0];
            lblElm.parentNode?.removeChild(lblElm);
          }
        }
      }
    }

    let lblElms = document.getElementsByClassName('mdc-label');
    for(let x=0;x<lblElms.length;x++){
      try{
        let inputElms = lblElms[x].getElementsByTagName('input');
        if(inputElms.length>0){
          lblElms[x].setAttribute('for', inputElms[0].id);
        }
      }catch(e){
        console.log(e);
      }
    }

    var ele = document.querySelectorAll("input[type=checkbox]");
    for(let x=0;x<ele.length;x++){
      try{
        let proceedFlag = false;
        let immParent = <HTMLDivElement>(ele[x].parentNode);
        if(immParent.getElementsByTagName('label').length>0){
          proceedFlag = true;
        }
        if(!proceedFlag){
          let parent = <HTMLDivElement>(ele[x].parentNode?.parentNode?.parentNode);
          let lblElm = parent.getElementsByTagName('label')[0];
          let cln = lblElm.cloneNode(true);
          // ele[x].parentNode?.appendChild(cln);
          ele[x].parentNode?.insertBefore(cln, ele[x]); 
          let lblAr = parent.getElementsByTagName('label');
          lblAr[0].className = ' hidden';
          lblAr[0].setAttribute('for', ele[x].id);
          ele[x].setAttribute('aria-labelledby', ele[x].id);
          let newElement = document.createElement("span");
          newElement.innerHTML = lblAr[1].innerHTML;
          newElement.className = 'labelColor';
          lblAr[1].replaceWith(newElement);
        }
      }catch(e){
        console.log(e);
      }

    }

    let radioAr = document.querySelectorAll("input[type=radio]");
    for(let x=0;x<radioAr.length;x++){
      try{
        //if(radioAr[x].getAttribute('data-form-type')=="other"){
          let divElm = <HTMLDivElement>(radioAr[x].parentNode?.parentNode?.parentNode);
          let lblObj =divElm.getElementsByTagName('label');
          if(lblObj.length==1 && lblObj[0].innerText.indexOf("Other")>-1){
              let lbl = document.createElement('label');
              lbl.innerHTML = 'other';
              lbl.className = 'hidden';
              lbl.setAttribute("for", radioAr[x].id);
              radioAr[x].setAttribute("aria-labelledby", radioAr[x].id);
              radioAr[x].insertAdjacentElement("beforebegin", lbl);
              //lblObj[0].setAttribute("for", radioAr[x].id);
          }
       // }
      }catch(e){}
    }
  }

  /**
   * 
   */
  ngOnInit(): void {

    this._responsive.observe([Breakpoints.Small, Breakpoints.HandsetPortrait]).subscribe(result => {
      this.isPhonePortrait = false;
      if (result.matches) {
        this.isPhonePortrait = true;
      }
    });

    // pull patient term and preview mode
    combineLatest([this._sharedDataService.previewMode$, this._sharedDataService.patientTerm$])
      .subscribe(([isPreview, patientTerm]) => {
        this.isPreview = isPreview
        this.patientTerm = patientTerm
      }
    )
    this.isOtherTextBoxDisabled = this.question.answers.find(ans => ans.scaleValue === '996' && ans.selected) ? false : true
    this.isOtherTextboxValid = this.isOtherTextBoxDisabled ? true : this.question.responseText.trim() !== ""
  }

  /**
   * 
   * @param text 
   */
  updateOtherTextBoxValidity(text: string) { // TODO text might be an event...
    this.isOtherTextboxValid = text.trim() === "" ? false : true
    this.question.responseText = text
  }

  /**
   * 
   * @param text 
   */
  saveOtherTextBoxAnswer() {

    // update Text Box Validity
    this.updateOtherTextBoxValidity(this.question.responseText)

    if(!this.isOtherTextboxValid) {
      return
    }

    const otherTextBoxAnswer = this.question.answers.find(ans => ans.scaleValue === '996')
    if(otherTextBoxAnswer === undefined) {
      throw throwError('Answer was not found')
    }

    const responseAnswerUpdateRequest : ResponseAnswerUpdateRequest = {
      responseId: this._sharedDataService.questionnaireResponse!.responseId,
      question: {
        questionId: this.question.questionId,
        responseText: this.question.responseText,
        answers: [
          {
            ...otherTextBoxAnswer,
            selected: true,
            responseTimestamp: DateUtil.toISOString(new Date())
          }
        ]
      },
      isPreview: this.isPreview
    }

    this._responseService.updateSingleAnswerForResponse(responseAnswerUpdateRequest).subscribe(() => {
      // update global questions
      this.question.answers = this.question.answers.map(ans => {
        ans.selected = ans.answerId === otherTextBoxAnswer.answerId
        return ans
      })
      this.question.isAnswered = true;
    })
  }

  /**
   * Save selection other than Other-Textbox
   * @param selectedAnswer 
   */
  saveSelection(selectedAnswer: QuestionnaireResponseAnswer) {

    if(selectedAnswer.scaleValue === '996') {
      this.isOtherTextBoxDisabled = false
      this.isOtherTextboxValid = false
      this.question.isAnswered = false;
      return
    }

    const selectedAnswerTemp = this.question.answers.find(ans => ans.answerId === selectedAnswer.answerId)
    if(selectedAnswerTemp === undefined) {
      throw throwError('Answer was not found')
    }

    this.question.responseText = ""
    const responseAnswerUpdateRequest : ResponseAnswerUpdateRequest = {
      responseId: this._sharedDataService.questionnaireResponse!.responseId,
      question: {
        questionId: this.question.questionId,
        responseText: this.question.responseText,
        answers: [
          {
            ...selectedAnswerTemp,
            selected: true,
            responseTimestamp: DateUtil.toISOString(new Date())
          }
        ]
      },
      isPreview: this.isPreview
    }

    this._responseService.updateSingleAnswerForResponse(responseAnswerUpdateRequest).subscribe(() => {
      this.isOtherTextboxValid = this.isOtherTextBoxDisabled = true
      // update global questions
      this.question.answers = this.question.answers.map(ans => {
        ans.selected = ans.answerId === selectedAnswerTemp.answerId
        return ans
      })
      this.question.isAnswered = true;
    })
  }
}